export default __webpack_public_path__ + "static/media/2.296ea45f.png";